<template>
  <div id="app">
    <template v-if="!outRoute">
      <el-container>
        <el-header :class="showShadow ? 'shadow' : ''">
          <!-- PC端导航 -->
          <div class="header-content">
            <div class="logo" @click="toHome">
              <!-- <img src="./assets/img/logo.png" alt /> -->
               <img src="./assets/img/iclb-icon.png" alt />
            </div>
            <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" :router="router">
              <el-menu-item index="/">首页</el-menu-item>
              <el-menu-item index="/product">产品介绍</el-menu-item>
              <el-menu-item index="/download">产品下载</el-menu-item>
              <el-menu-item index="/about">关于我们</el-menu-item>
              <!-- <el-menu-item index="/document">API文档</el-menu-item> -->
            </el-menu>
          </div>
          <!-- 手机端导航 -->
          <div class="phone-header">
            <img class="logo" @click="toHome" src="./assets/img/iclb-icon.png" alt />
            <img class="menu-icon" v-if="!openMenu" @click="showMenu(true)" src="./assets/img/menu.png" alt />
            <img class="menu-icon" v-else @click="showMenu(false)" src="./assets/img/close.png" alt />
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
        <div class="footer" v-if="$route.path !== '/downloadSbb'&&$route.path !== '/downloadApp'">
          <!-- 替换图片为代码实现 -->
          <div class="footer-content">
            <div class="footer-qr">
              <!-- 这里需要您的二维码图片 -->
              <img src="./assets/img/footer_qccode.png" alt="微信公众号" class="qrcode" />
              
            </div>
            <div class="footer-info">
              <div class="contact-item">
                <span class="label">商务邮箱：</span>
                <span class="value">laibu_market@iclab.ltd</span>
              </div>
              <div class="contact-item">
                <span class="label">反馈邮箱：</span>
                <span class="value">info@iclabs.cn</span>
              </div>
              <div class="contact-item">
                <span class="label">电话：</span>
                <span class="value">0571-87066659</span>
              </div>
              <div class="contact-item">
                <span class="label">地址：</span>
                <span class="value">杭州市西湖区灵隐街道玉古路172号灵隐人工智能产业基地409室</span>
              </div>
            </div>
          </div>
          <div class="footer-bottom">
            <div class="split"></div>
            <div class="copyright">
              <p>Copyright 2017-{{ new Date().getFullYear() }} 杭州来布科技有限公司 浙ICP备</p>
              <a target="_blank" href="https://beian.miit.gov.cn/" style="color: #666666; text-decoration: none">18004965</a>号-1 <img src="./assets/img/111.d0289dc0.png" alt="" />浙公网安备
              <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802008982" style="color: #666666; text-decoration: none">33010802008982</a>
              <p>号</p>
            </div>
            <div class="copyright-phone">
              <p>Copyright 2017-{{ new Date().getFullYear() }} 杭州来布科技有限公司</p>
              <div>
                <p>浙ICP备</p>
                <a target="_blank" href="https://beian.miit.gov.cn/" style="color: #666666; text-decoration: none">18004965</a>号-1
              </div>
              <div class="last">
                <img src="./assets/img/111.d0289dc0.png" alt="" />浙公网安备
                <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802008982" style="color: #666666; text-decoration: none">33010802008982</a>
                <p>号</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 手机端切换导航 -->
        <div :class="!openMenu ? 'switch-menu-wrap transform' : 'switch-menu-wrap'">
          <div class="menu-item" @click="toHome">首页</div>
          <div class="menu-item" @click="toProduct">产品介绍</div>
          <div class="menu-item" @click="toDownload">产品下载</div>
          <div class="menu-item" @click="toAbout">关于我们</div>
        </div>
      </el-container>
    </template>
    <router-view v-else />
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "",
      showShadow: false,
      openMenu: false,
      outRoute: false,
    };
  },

  watch: {
    "$route.fullPath": {
      immediate: true,
      handler(val) {
        this.defaultActive = val;
      },
    },
    "$route.meta": {
      immediate: true,
      handler(val) {
        if (val) {
          if (val.outRoute) {
            this.outRoute = true;
          } else {
            this.outRoute = false;
          }
        }
      },
    },
  },
  mounted() {
    // 添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    toHome() {
      this.$router.replace("/");
      this.openMenu = false;
    },
    toProduct() {
      this.$router.replace("/product");
      this.openMenu = false;
    },
    toDownload() {
      this.$router.replace("/download");
      this.openMenu = false;
    },
    toAbout() {
      this.$router.replace("/about");
      this.openMenu = false;
    },
    handleScroll() {
      this.showShadow = window.scrollY > 0;
    },
    beforeDestroy() {
      // 移除滚动事件监听
      window.removeEventListener("scroll", this.handleScroll);
    },
    showMenu(bool) {
      this.openMenu = bool;
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  user-select: none;
  box-sizing: border-box;
}
/*滚动条样式*/
::-webkit-scrollbar {
  width: 5px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background: #e0e2e4;
  border-radius: 5px;
}
::-webkit-scrollbar-track {
  border-radius: 0;
}
html,
body {
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
}
.el-container {
  min-height: 100%;
}
.footer {
  width: 100%;
  background: #eef1f9;
}
.footer-img {
  height: 237px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 446px;
  }
}
.footer-bottom {
  width: 100%;
  height: 72px;
  line-height: 72px;
  text-align: center;
  position: relative;
}

.footer-bottom .split {
  width: 100%;
  height: 1px;
  background: #dfe2eb;
}

.footer-bottom .copyright {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  > img {
    margin-left: 16px;
    margin-right: 5px;
  }
}
.footer-bottom .copyright-phone {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  display: none;
  img {
    margin-right: 5px;
  }
  .last {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.el-header {
  position: fixed;
  top: 0;
  z-index: 999;
  background: #fff;
  width: 100%;
  height: 64px !important;
  .header-content {
    width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding: 0 !important;
    .logo {
      margin-right: 126px;
      width: 212px;
      img {
        width: 100%;
      }
    }
    .logo:hover {
      cursor: pointer;
    }
  }
  .el-dropdown-menu__item,
  .el-menu-item {
    font-size: 16px;
    padding: 0;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #2f51ff;
    color: #262626;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  .el-menu--horizontal > .el-menu-item {
    color: #262626;
    margin: 0 36px;
    height: 41px;
    line-height: 41px;
  }
}
.phone-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  display: none;
  .logo {
    width: 36.5vw;
  }
  .menu-icon {
    width: 6.4vw;
  }
}
.switch-menu-wrap {
  display: none;
  position: fixed;
  bottom: 0;
  z-index: 99;
  background: #fff;
  width: 100%;
  height: calc(100% - 62px);
  .menu-item {
    font-size: 20px;
    color: #333333;
    padding: 15px 0;
    margin: 0 24px;
    border-bottom: 1px solid #eee;
  }
}
.shadow {
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.04);
}

.el-main {
  padding: 0 !important;
  min-height: 100%;
  margin-top: 64px;
}
.swiper-pagination {
  .swiper-pagination-bullet {
    width: 40px;
    height: 6px;
    background: #262626;
    border-radius: 60px 60px 60px 60px;
    opacity: 0.15;
    margin-right: 12px;
  }

  .swiper-pagination-bullet-active {
    opacity: 0.6;
  }
}
/* 替换原有的 .footer-img 样式 */
.footer-content {
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  
  .footer-qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .qrcode {
      width: 118px;
      height: 138px;
    }
    
    .qr-label {
      font-size: 14px;
      color: #666666;
      text-align: center;
    }
  }
  
  .footer-info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    .contact-item {
      display: flex;
      align-items: center;
      font-size: 16px;
      
      .label {
        color: #333333;
        font-weight: 500;
        min-width: 80px;
      }
      
      .value {
        color: #666666;
      }
    }
  }
}

/* 当屏幕宽度小于768像素时 */
@media screen and (max-width: 768px) {
  .el-header {
    width: 100%;
    padding: 0 24px !important;
    .header-content {
      display: none;
    }
  }
  .phone-header {
    display: flex;
  }
  .switch-menu-wrap {
    display: block;
    bottom: 0;
    transition: transform 0.6s ease-in-out; /* 设置过渡效果 */
  }
  .switch-menu-wrap.transform {
    transform: translateY(-108%); /* 初始状态下，页面向上移动100%的高度 */
  }
  .footer-bottom {
    line-height: 20px;
    font-size: 12px;
    height: 80px;
  }
  .footer-img {
    height: 200px;
    img {
      width: 346px;
    }
  }
  .footer-bottom .copyright {
    display: none;
  }
  .footer-bottom .copyright-phone {
    display: block;
    margin-top: 5px;
    p {
      display: inline;
    }
  }
   .footer-content {
    flex-direction: column;
    align-content: center;
    gap: 20px;
    padding: 20px 20px;
    
    .footer-qr {

      .qrcode {
        width: 98px;
        height: 108px;
      }
    }
    
    .footer-info {
      gap: 12px;
      
      .contact-item {
        font-size: 14px;
        // flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        
        .value {
          min-width: auto;
        }
      }
    }
  }
}
</style>
